/* AagamStuti home page. Plain JavaScript, no libraries. Loaded by layout/theme.liquid on the home page only.
   1. Chips ([data-hm-tabs]): switch the product grid under the chips without a reload (arrow keys, Home and End work too).
   2. Shelf by shelf ([data-hm-shelves]): on a phone the shelves slide sideways; the dots follow the swipe and move to a shelf when tapped.
   3. Round add buttons: show a tick for a moment after the theme's quick-add has added the piece (the theme's own handler does the adding).
   4. Festival cards ([data-fc][data-style="card"]): once the festive script has drawn them, add the days to go after the date ("Tue 20 Oct · in 7 days"). */
(function () {
  'use strict';

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- 1. chips ---------- */
  function initTabs(root) {
    if (root.__hmTabs) return;
    root.__hmTabs = true;
    var tabs = $$('[data-hm-tab]', root);
    var panels = $$('.hm-panel', root);
    if (!tabs.length || tabs.length !== panels.length) return;

    function show(i, focus) {
      tabs.forEach(function (t, n) {
        var on = n === i;
        t.classList.toggle('is-on', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        panels[n].hidden = !on;
      });
      if (focus) tabs[i].focus();
      // keep the chosen chip in view on a phone, where the chips scroll sideways
      var row = tabs[i].parentNode;
      if (row && row.scrollWidth > row.clientWidth) {
        var left = tabs[i].offsetLeft - (row.clientWidth - tabs[i].offsetWidth) / 2;
        row.scrollTo({ left: left, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(i, false); });
      t.addEventListener('keydown', function (e) {
        var n = tabs.length, k = e.key, to = -1;
        if (k === 'ArrowRight') to = (i + 1) % n;
        else if (k === 'ArrowLeft') to = (i - 1 + n) % n;
        else if (k === 'Home') to = 0;
        else if (k === 'End') to = n - 1;
        if (to < 0) return;
        e.preventDefault();
        show(to, true);
      });
    });
  }

  /* ---------- 2. shelf by shelf ---------- */
  function initShelves(root) {
    if (root.__hmShelves) return;
    root.__hmShelves = true;
    var track = root.querySelector('[data-hm-track]');
    var dots = $$('[data-hm-dots] button', root);
    if (!track) return;
    var cards = $$('.hm-shelf', track);
    var phone = window.matchMedia('(max-width: 699px)');

    function scrollable() { return phone.matches && track.scrollWidth > track.clientWidth + 2; }
    function pad() { return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0; }
    // how far each shelf's left edge is from where a snapped shelf rests (the track's left edge plus its scroll padding)
    function offset(c) { return c.getBoundingClientRect().left - track.getBoundingClientRect().left - pad(); }
    function current() {
      var best = 0, bestD = Infinity;
      cards.forEach(function (c, i) {
        var d = Math.abs(offset(c));
        if (d < bestD) { bestD = d; best = i; }
      });
      // at the very end the last shelf may not reach the left edge, so light the last dot
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = cards.length - 1;
      return best;
    }
    function mark() {
      var i = current();
      dots.forEach(function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
    }
    function go(i) {
      var c = cards[i];
      if (!c) return;
      track.scrollTo({ left: track.scrollLeft + offset(c), behavior: reduce ? 'auto' : 'smooth' });
    }
    function sync() {
      // a scrolling box must be reachable from the keyboard; on a computer the shelves are a plain grid
      if (scrollable()) {
        track.tabIndex = 0;
        track.setAttribute('aria-label', 'Shelves. Swipe sideways to see the next one.');
      } else {
        track.removeAttribute('tabindex');
        track.setAttribute('aria-label', 'Shelves');
      }
      mark();
    }

    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = 0; mark(); });
    }, { passive: true });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    track.addEventListener('keydown', function (e) {
      if (!scrollable()) return;
      var i = current();
      if (e.key === 'ArrowRight' && i < cards.length - 1) { e.preventDefault(); go(i + 1); }
      else if (e.key === 'ArrowLeft' && i > 0) { e.preventDefault(); go(i - 1); }
    });
    if (phone.addEventListener) phone.addEventListener('change', sync); else if (phone.addListener) phone.addListener(sync);
    window.addEventListener('resize', mark);
    sync();
  }

  /* ---------- 3. a tick on the round add buttons ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.hm-plus[data-quick-add], .hm-qc__add[data-quick-add]') : null;
    if (!b || b.__hmWatch) return;
    b.__hmWatch = true;
    var label = b.querySelector('span');
    if (!label || !window.MutationObserver) return;
    new MutationObserver(function () {
      var t = label.textContent || '';
      b.classList.toggle('is-added', /added/i.test(t));
      b.classList.toggle('is-fail', /unavailable|try again/i.test(t));
    }).observe(label, { childList: true, characterData: true, subtree: true });
  }, true);

  /* ---------- 4. festival cards ---------- */
  function initFest(root) {
    if (root.__hmFest) return;
    root.__hmFest = true;
    var body = root.querySelector('[data-fc-body]');
    if (!body) return;
    function fix() {
      $$('.as-fs__card', body).forEach(function (c) {
        if (c.__hmDone) return;
        var w = c.querySelector('.as-fs__when'), p = c.querySelector('.as-fpill');
        if (!w || !p) return;
        w.textContent = w.textContent + ' \u00b7 ' + p.textContent.toLowerCase();
        c.__hmDone = true;
      });
    }
    if (window.MutationObserver) new MutationObserver(fix).observe(body, { childList: true, subtree: true });
    fix();
  }

  function scan(ctx) {
    $$('[data-hm-tabs]', ctx).forEach(initTabs);
    $$('[data-hm-shelves]', ctx).forEach(initShelves);
    $$('[data-fc][data-style="card"]', ctx).forEach(initFest);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
